import React, { useState, useEffect, FC } from 'react'
import CarouselConnector, {
  ConnectorProps as CarouselProps,
} from '../../../connectors/CarouselABTest'
import { ALGOLIA } from '../../../helpers/constants'
import Carousel from './Carousel'
import { getArtistArtworks, clickArtwork } from '../helpers'
import { Section } from './styles'
import { getAlgoliaQueryIDFromLocalStorage } from 'lib/algolia/v2/helpers'
import classNames from 'classnames'
import { capitalizeString } from 'lib/helpers'

const MIN_ARTWORKS = 5
const LIST = 'more-from-artist'
type RecommendedArtworksCarouselProps = CarouselProps & {
  setShouldLoadComponent: (...args: Array<any>) => any
}

const RecommendedArtworksCarousel: FC<RecommendedArtworksCarouselProps> = (props) => {
  const [artworks, handleArtworks] = useState([])
  const {
    artistInfo,
    artworkId,
    artistSeeMore,
    sku,
    setShouldLoadComponent,
    algoliaSearchIndex,
    algoliaUserToken,
    userID,
  } = props
  const { firstName, lastName, userId } = artistInfo
  const capitalizedFullName = capitalizeString(`${firstName || ''} ${lastName || ''}`)
  const algoliaQueryIdFromLocalStorage = getAlgoliaQueryIDFromLocalStorage()
  useEffect(() => {
    getArtistArtworks({
      abTest: true,
      callBack: handleArtworks,
      firstName,
      lastName,
      sku,
      userId,
    })
  }, [artworkId])

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  return (
    <Section data-section={LIST}>
      <h4
        className={classNames('defaultTypographyH4', 'defaultTextBold')}
        data-type='artist-carousel-title'
      >
        More From {capitalizedFullName}
      </h4>
      <Carousel
        artworks={artworks}
        clickArtwork={(ev) => {
          setShouldLoadComponent(false)
          clickArtwork(ev, algoliaSearchIndex, algoliaUserToken, userID)
        }}
        dataApi={ALGOLIA}
        dataList={`${LIST}-pdp`}
        dataListId={`${LIST}-pdp`}
        dataListName={`More From ${capitalizedFullName}`}
        seeMore={artistSeeMore}
        algoliaSearchIndex={algoliaSearchIndex}
        algoliaUserToken={algoliaUserToken}
        algoliaQueryID={algoliaQueryIdFromLocalStorage}
        userID={userID}
      />
    </Section>
  )
}

export default CarouselConnector(RecommendedArtworksCarousel)
